/* Shopify-verified campaign snapshots. Date changes are made by the authorized scheduler, never by this browser model. */
(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.MDCAdvantageModel=factory();
}(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  var neutralText='Les avantages disponibles sont confirmés au panier.';
  var giftCode='SALEPIFY PROMOTION - 20260903_072555 - FREE GIFT';
  function instant(v){return typeof v==='string'&&/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(v)?Date.parse(v):NaN;}
  function clean(v){return typeof v==='string'?v.trim():'';}
  function validCode(v){return typeof v==='string'&&v===v.trim()&&v.length>0&&v.length<=255&&!/[,\u0000-\u001f\u007f]/.test(v)&&/15$/.test(v);}
  function validOffer(o,ids,allowExpired){
    return o&&ids.indexOf(o.id)!==-1&&o.type==='DiscountCodeBasic'&&
      validCode(o.code)&&o.codeCount===1&&o.percentage===0.15&&
      o.allCustomers===true&&o.allItems===true&&o.minimumRequirement===null&&
      o.appliesOnOneTimePurchase===true&&o.usageLimit===null&&
      (allowExpired?['ACTIVE','SCHEDULED','EXPIRED']:['ACTIVE','SCHEDULED']).indexOf(o.status)!==-1&&
      Number.isFinite(instant(o.startsAt))&&Number.isFinite(instant(o.endsAt))&&
      instant(o.endsAt)>instant(o.startsAt);
  }
  function selectOffer(now,config,context){
    var neutral={available:false,message:neutralText}, time=new Date(now).getTime();
    context=context||{};
    var manual=config&&config.schemaVersion===2&&config.source==='shopify-verified-manual'&&config.automaticSyncEnabled===false;
    var synchronized=config&&config.schemaVersion===3&&config.source==='shopify-verified-metafield'&&config.automaticSyncEnabled===true;
    var rolling=config&&config.schemaVersion===4&&config.source==='shopify-verified-metafield'&&
      config.policy==='rolling-daily'&&config.horizonDays===5&&typeof config.automaticSyncEnabled==='boolean';
    if(!config||(!manual&&!synchronized&&!rolling)||config.enabled!==true||context.country!=='FR'||
      config.timeZone!==(rolling?'America/Toronto':'Europe/Paris')||!Number.isFinite(time)||
      !Array.isArray(config.offers)||!config.offers.length||config.offers.length>20)return neutral;
    var ids=config.trackedIds, verified=instant(config.verifiedAt), deadline=instant(config.validUntil);
    if(!Array.isArray(ids)||ids.length!==config.offers.length||new Set(ids).size!==ids.length||
      ids.some(function(id){return typeof id!=='string'||!/^gid:\/\/shopify\/DiscountCodeNode\/\d+$/.test(id);})||
      !Number.isFinite(verified)||verified>time+60000||!Number.isFinite(deadline)||verified>=deadline||
      config.offers.some(function(o){return !validOffer(o,ids,rolling);})||
      new Set(config.offers.map(function(o){return o.id;})).size!==ids.length||
      new Set(config.offers.map(function(o){return o.code.toUpperCase();})).size!==ids.length||
      deadline!==Math.max.apply(null,config.offers.map(function(o){return instant(o.endsAt);})))return neutral;
    if(synchronized||rolling){
      var fresh=instant(config.freshUntil);
      if(!Number.isFinite(fresh)||fresh<=verified||fresh-verified>52*3600000||time>=fresh)return neutral;
    }
    if(time>=deadline)return {available:false,message:'Cette offre est terminée.'};
    if(rolling){
      var monthParts=new Intl.DateTimeFormat('en-CA',{year:'numeric',month:'2-digit',timeZone:config.timeZone}).formatToParts(new Date(time));
      var monthValues={};
      monthParts.forEach(function(part){monthValues[part.type]=part.value;});
      if(config.registryMonth!==monthValues.year+'-'+monthValues.month||ids.indexOf(config.featuredOfferId)===-1)return neutral;
    }
    var active=config.offers.filter(function(o){return (!rolling||o.id===config.featuredOfferId)&&
      o.status!=='EXPIRED'&&time>=instant(o.startsAt)&&time<instant(o.endsAt);});
    if(active.length!==1)return neutral;
    var offer=active[0], end=new Date(instant(offer.endsAt));
    var shortDate=new Intl.DateTimeFormat('fr-FR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23',timeZone:config.timeZone});
    var fullDate=new Intl.DateTimeFormat('fr-FR',{day:'numeric',month:'long',year:'numeric',hour:'2-digit',minute:'2-digit',hourCycle:'h23',timeZone:config.timeZone});
    var timeZoneLabel=rolling?'heure de Toronto':'heure de Paris';
    var validityText='Code actuellement valable jusqu’au '+fullDate.format(end)+' ('+timeZoneLabel+').';
    var renewalText=rolling&&config.automaticSyncEnabled?'Offre renouvelée quotidiennement. ':'';
    if(rolling&&config.previewOnly===true)renewalText='Aperçu — '+renewalText;
    return {available:true,code:offer.code,percentage:offer.percentage,discountLabel:'−'+Math.round(offer.percentage*100)+' %',
      startText:'Début le '+fullDate.format(new Date(instant(offer.startsAt))),
      expiryText:rolling?renewalText+validityText:'Fin le '+shortDate.format(end)+' (Paris)',
      expiryDescription:rolling?renewalText+validityText:'Le code expire le '+fullDate.format(end)+' (heure de Paris).',
      codeExpiresAt:offer.endsAt,conditionsText:(offer.appliesOncePerCustomer===true?'Une utilisation par client. ':'')+'Remise confirmée au panier.',
      timeZoneLabel:timeZoneLabel,validUntil:end.toISOString()};
  }
  function mergeCodes(existing,code){
    code=clean(code);
    if(!validCode(code))return [];
    var result=[code];
    // Replace every previous percentage code; preserve only the verified gift code.
    (Array.isArray(existing)?existing:[]).forEach(function(entry){
      var value=clean(typeof entry==='string'?entry:entry&&entry.code);
      if(value.toUpperCase()===giftCode&&result.length===1)result.push(value);
    });
    return result;
  }
  return {selectOffer:selectOffer,mergeCodes:mergeCodes,neutralText:neutralText};
}));
